(function () {
  document.body.classList.add('eden-theme');

  var CART_KEY = 'eden_demo_cart';

  function moneyBRL(value) {
    return (Number(value) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function buildDemoGallery(product) {
    var seed = product.image || (product.images && product.images[0]) || '';
    var line = String(product.line || product.name || '').toLowerCase();
    var names;
    if (line.indexOf('macbook') !== -1) {
      names = ['eden-hero-macbook.png', 'eden-ig-1.png', 'eden-ig-2.png', 'eden-about.png', 'eden-ig-3.png'];
    } else if (line.indexOf('watch') !== -1) {
      names = ['eden-hero-watch.png', 'eden-ig-2.png', 'eden-ig-3.png', 'eden-ig-4.png', 'eden-ig-1.png'];
    } else if (line.indexOf('airpods') !== -1) {
      names = ['eden-hero-airpods.png', 'eden-ig-1.png', 'eden-ig-3.png', 'eden-ig-4.png', 'eden-ig-2.png'];
    } else if (line.indexOf('ipad') !== -1) {
      names = ['eden-ig-3.png', 'eden-ig-4.png', 'eden-ig-1.png', 'eden-about.png', 'eden-ig-2.png'];
    } else {
      names = ['eden-hero.png', 'eden-ig-1.png', 'eden-ig-2.png', 'eden-ig-3.png', 'eden-ig-4.png'];
    }
    if (!seed) return names;
    var match = seed.match(/eden-[a-z0-9-]+\.(png|jpe?g|webp)/i);
    if (!match) return [seed].concat(names).slice(0, 5);
    return names.map(function (name) {
      return seed.replace(match[0], name);
    });
  }

  function getDemoProducts() {
    var node = document.querySelector('[data-eden-demo-data]');
    if (!node) return [];
    try {
      var products = JSON.parse(node.textContent);
      return products.map(function (p) {
        if (!p.images || p.images.length < 2) {
          p.images = buildDemoGallery(p);
        }
        if (!p.image && p.images.length) p.image = p.images[0];
        if (typeof p.stock === 'undefined') p.stock = 1;
        if (!p.model) p.model = p.name;
        if (!p.warranty_info) p.warranty_info = 'Garantia Eden informada no atendimento.';
        if (!p.origin_info) p.origin_info = 'Selecionado pela Eden Mobile';
        if (!p.invoice_info) p.invoice_info = 'Nota fiscal, quando aplicável';
        if (!p.description) {
          p.description =
            p.name +
            (p.color ? ' em ' + p.color.toLowerCase() : '') +
            ', selecionado pela Eden Mobile. Conferido item a item antes do envio.';
        }
        // Linha de filtro no estilo Base44 (Pro / Pro Max / Plus)
        if (!p.filter_line) {
          var n = (p.name || '').toLowerCase();
          if (n.indexOf('pro max') !== -1) p.filter_line = 'iPhone Pro Max';
          else if (n.indexOf('pro') !== -1 && n.indexOf('iphone') !== -1) p.filter_line = 'iPhone Pro';
          else if (n.indexOf('plus') !== -1 && n.indexOf('iphone') !== -1) p.filter_line = 'iPhone Plus';
          else if (n.indexOf('iphone') !== -1) p.filter_line = 'iPhone';
          else if (n.indexOf('macbook air') !== -1) p.filter_line = 'MacBook Air';
          else if (n.indexOf('macbook pro') !== -1) p.filter_line = 'MacBook Pro';
          else if (n.indexOf('ipad air') !== -1) p.filter_line = 'iPad Air';
          else if (n.indexOf('ipad pro') !== -1) p.filter_line = 'iPad Pro';
          else if (n.indexOf('ipad mini') !== -1) p.filter_line = 'iPad mini';
          else if (n.indexOf('ipad') !== -1) p.filter_line = 'iPad';
          else if (n.indexOf('ultra') !== -1 && n.indexOf('watch') !== -1) p.filter_line = 'Apple Watch Ultra';
          else if (n.indexOf('series') !== -1) p.filter_line = 'Apple Watch Series';
          else if (n.indexOf('watch se') !== -1 || n.indexOf('watch se') !== -1) p.filter_line = 'Apple Watch SE';
          else if (n.indexOf('airpods max') !== -1) p.filter_line = 'AirPods Max';
          else if (n.indexOf('airpods pro') !== -1) p.filter_line = 'AirPods Pro';
          else if (n.indexOf('airpods') !== -1) p.filter_line = 'AirPods';
          else p.filter_line = p.line || '';
        }
        if (!p.filter_model) p.filter_model = detectIphoneModel(p.name || p.model || '');
        return p;
      });
    } catch (e) {
      return [];
    }
  }

  function detectProductModel(text) {
    var t = String(text || '').toLowerCase();
    if (!t) return '';
    if (t.indexOf('iphone 17 air') !== -1 || t.indexOf('iphone air') !== -1) return 'iPhone 17 Air';
    if (t.indexOf('iphone 17 pro max') !== -1) return 'iPhone 17 Pro Max';
    if (t.indexOf('iphone 17 pro') !== -1) return 'iPhone 17 Pro';
    if (t.indexOf('iphone 17') !== -1) return 'iPhone 17';
    if (t.indexOf('iphone 16e') !== -1) return 'iPhone 16e';
    if (t.indexOf('iphone 16 plus') !== -1) return 'iPhone 16 Plus';
    if (t.indexOf('iphone 16 pro max') !== -1) return 'iPhone 16 Pro Max';
    if (t.indexOf('iphone 16 pro') !== -1) return 'iPhone 16 Pro';
    if (t.indexOf('iphone 16') !== -1) return 'iPhone 16';
    if (t.indexOf('ipad pro') !== -1) return 'iPad Pro';
    if (t.indexOf('ipad air') !== -1) return 'iPad Air';
    if (t.indexOf('ipad mini') !== -1) return 'iPad mini';
    if (t.indexOf('ipad') !== -1) return 'iPad';
    if (t.indexOf('macbook air') !== -1) return 'MacBook Air';
    if (t.indexOf('macbook pro') !== -1) return 'MacBook Pro';
    if (t.indexOf('imac') !== -1) return 'iMac';
    if (t.indexOf('mac mini') !== -1 || t.indexOf('mac-mini') !== -1) return 'Mac mini';
    if (t.indexOf('ultra') !== -1 && t.indexOf('watch') !== -1) return 'Apple Watch Ultra 2';
    if (t.indexOf('series 10') !== -1 || (t.indexOf('series') !== -1 && t.indexOf('watch') !== -1)) return 'Apple Watch Series 10';
    if (t.indexOf('watch se') !== -1) return 'Apple Watch SE';
    if (t.indexOf('airpods max') !== -1) return 'AirPods Max';
    if (t.indexOf('airpods pro') !== -1) return 'AirPods Pro 2';
    if (t.indexOf('airpods') !== -1) return 'AirPods 4';
    return '';
  }

  function detectIphoneModel(text) {
    return detectProductModel(text);
  }

  function detectProductLine(text, fallback) {
    var t = String(text || '').toLowerCase();
    var model = detectProductModel(t);
    if (model.indexOf('iPhone 17 Air') === 0 || model === 'iPhone 17 Air') return 'iPhone Air';
    if (model.indexOf('Pro Max') !== -1) return 'iPhone Pro Max';
    if (model.indexOf('iPhone') !== -1 && model.indexOf('Pro') !== -1) return 'iPhone Pro';
    if (model.indexOf('Plus') !== -1) return 'iPhone';
    if (model.indexOf('iPhone') !== -1) return 'iPhone';
    if (model.indexOf('MacBook Air') !== -1) return 'MacBook Air';
    if (model.indexOf('MacBook Pro') !== -1) return 'MacBook Pro';
    if (model.indexOf('iMac') !== -1) return 'iMac';
    if (model.indexOf('Mac mini') !== -1) return 'Mac mini';
    if (model.indexOf('iPad Pro') !== -1) return 'iPad Pro';
    if (model.indexOf('iPad Air') !== -1) return 'iPad Air';
    if (model.indexOf('iPad mini') !== -1) return 'iPad mini';
    if (model.indexOf('iPad') !== -1) return 'iPad';
    if (model.indexOf('Ultra') !== -1) return 'Apple Watch Ultra';
    if (model.indexOf('Series') !== -1) return 'Apple Watch Series';
    if (model.indexOf('Watch SE') !== -1) return 'Apple Watch SE';
    if (model.indexOf('AirPods Max') !== -1) return 'AirPods Max';
    if (model.indexOf('AirPods Pro') !== -1) return 'AirPods Pro';
    if (model.indexOf('AirPods') !== -1) return 'AirPods';
    return fallback || '';
  }

  function readCart() {
    try {
      return JSON.parse(localStorage.getItem(CART_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeCart(items) {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    updateCartBadge();
    window.dispatchEvent(new CustomEvent('eden:cart-updated'));
  }

  function cartCount(items) {
    return (items || readCart()).reduce(function (sum, i) {
      return sum + (i.quantity || 1);
    }, 0);
  }

  function updateCartBadge() {
    var count = cartCount();
    document.querySelectorAll('[data-eden-cart-link]').forEach(function (link) {
      var badge = link.querySelector('.eden-header__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'eden-header__badge';
          link.appendChild(badge);
        }
        badge.textContent = String(count);
        badge.hidden = false;
      } else if (badge) {
        badge.hidden = true;
      }
    });
  }

  function addToCart(product, quantity) {
    quantity = quantity || 1;
    var items = readCart();
    var found = items.find(function (i) {
      return i.id === product.id;
    });
    if (found) {
      found.quantity += quantity;
    } else {
      items.push({
        id: product.id,
        name: product.name,
        storage: product.storage || '',
        color: product.color || '',
        price: product.price,
        image: product.image,
        quantity: quantity
      });
    }
    writeCart(items);
    showToast('Adicionado ao carrinho');
  }

  function showToast(message) {
    var el = document.querySelector('[data-eden-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'eden-toast';
      el.setAttribute('data-eden-toast', '');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2200);
  }

  function cardHTML(p, labels) {
    labels = labels || {};
    var buy = labels.buy || 'Comprar';
    var details = labels.details || 'Ver detalhes';
    var installmentsPrefix = labels.installmentsPrefix || 'ou';
    var installments = p.installments || labels.installments || 12;
    var parcela = (p.price || 0) / installments;
    var meta = [p.storage, p.color].filter(Boolean).join(' · ');
    var badge = [p.condition, p.condition_grade].filter(Boolean).join(' — ');
    var specs = '';
    if (p.storage) specs += '<span>' + p.storage + '</span>';
    if (p.color) specs += '<span>' + p.color + '</span>';
    if (p.battery_health) specs += '<span>Bateria ' + p.battery_health + '%</span>';
    var url = '/products/' + p.id;
    return (
      '<article class="eden-card eden-card--demo" data-eden-product-id="' + p.id + '">' +
      '<a href="' + url + '" class="eden-card__media">' +
      '<img src="' + p.image + '" alt="' + p.name + '" width="600" height="750" loading="lazy">' +
      '<div class="eden-card__specs">' + specs + '</div>' +
      '</a>' +
      '<div class="eden-card__body">' +
      '<a href="' + url + '" class="eden-card__title">' + p.name + '</a>' +
      '<p class="eden-card__meta">' + meta + '</p>' +
      '<span class="eden-card__badge">' + badge + '</span>' +
      '<div class="eden-card__price">' + moneyBRL(p.price) + '</div>' +
      '<p class="eden-card__installments">' + installmentsPrefix + ' ' + installments + 'x de ' + moneyBRL(parcela) + '</p>' +
      '<div class="eden-card__actions">' +
      '<button type="button" class="eden-btn eden-btn--primary" data-eden-add-cart>' + buy + '</button>' +
      '<a href="' + url + '" class="eden-btn eden-btn--outline">' + details + '</a>' +
      '</div></div></article>'
    );
  }

  function initCatalogPage() {
    var page = document.querySelector('[data-eden-catalog-page]');
    if (!page) return;

    var collection = (page.getAttribute('data-eden-collection') || '').toLowerCase();
    var grid = page.querySelector('[data-eden-catalog-grid]');
    var countEl = page.querySelector('[data-eden-catalog-count]');
    var emptyEl = page.querySelector('[data-eden-catalog-empty]');
    var searchInput = page.querySelector('[data-eden-catalog-search]');
    var priceInput = page.querySelector('[data-eden-catalog-price]');
    var priceLabel = page.querySelector('[data-eden-catalog-price-label]');
    var titleEl = page.querySelector('[data-eden-catalog-title]');
    var isDemo = !!(grid && grid.hasAttribute('data-eden-demo-catalog'));
    var uiLabels = {
      buy: page.getAttribute('data-ui-buy') || 'Comprar',
      details: page.getAttribute('data-ui-details') || 'Ver detalhes',
      unavailable: page.getAttribute('data-ui-unavailable') || 'Indisponível',
      installmentsPrefix: page.getAttribute('data-ui-installments-prefix') || 'ou',
      installments: parseInt(page.getAttribute('data-ui-installments') || '12', 10) || 12,
      pricePrefix: page.getAttribute('data-ui-price-prefix') || 'Até'
    };

    var state = { line: '', model: '', storage: '', color: '', price: 0, q: '' };
    var params = new URLSearchParams(window.location.search);
    if (params.get('q')) state.q = params.get('q');
    if (params.get('linha')) state.line = params.get('linha');
    if (params.get('modelo')) state.model = params.get('modelo');
    if (searchInput && state.q) searchInput.value = state.q;

    var products = [];
    if (isDemo) {
      products = getDemoProducts().filter(function (p) {
        if (!collection) return true;
        return (p.collections || []).some(function (c) {
          return c === collection || c.indexOf(collection + '-') === 0;
        });
      });
    } else {
      products = Array.prototype.slice.call(page.querySelectorAll('[data-eden-catalog-card]')).map(function (card) {
        var title = card.getAttribute('data-search') || '';
        var modelAttr = card.getAttribute('data-model') || '';
        var lineAttr = card.getAttribute('data-line') || '';
        var colorsAttr = card.getAttribute('data-colors') || card.getAttribute('data-color') || '';
        var colors = colorsAttr
          .split(',')
          .map(function (c) {
            return c.trim();
          })
          .filter(Boolean);
        return {
          el: card,
          name: title,
          line: lineAttr,
          filter_line: lineAttr || detectProductLine(title, ''),
          filter_model: modelAttr || detectProductModel(title),
          storage: card.getAttribute('data-storage') || '',
          color: colors[0] || '',
          colors: colors,
          condition: card.getAttribute('data-condition') || '',
          price: parseInt(card.getAttribute('data-price-cents') || '0', 10) / 100,
          search: title
        };
      });
    }

    function uniq(arr) {
      return arr.filter(function (v, i, a) {
        return v && a.indexOf(v) === i;
      });
    }

    var PRESET_FILTERS = {
      iphone: {
        lines: ['iPhone', 'iPhone Air', 'iPhone Pro', 'iPhone Pro Max'],
        models: [
          'iPhone 17',
          'iPhone 17 Air',
          'iPhone 17 Pro',
          'iPhone 17 Pro Max',
          'iPhone 16e',
          'iPhone 16',
          'iPhone 16 Plus',
          'iPhone 16 Pro',
          'iPhone 16 Pro Max'
        ],
        storages: ['128GB', '256GB', '512GB', '1TB', '2TB'],
        colors: [
          'Preto',
          'Branco',
          'Azul',
          'Rosa',
          'Verde',
          'Amarelo',
          'Grafite',
          'Prata',
          'Dourado',
          'Azul-titânio'
        ]
      },
      mac: {
        lines: ['MacBook Air', 'MacBook Pro', 'iMac', 'Mac mini'],
        models: ['MacBook Air', 'MacBook Pro', 'iMac', 'Mac mini'],
        storages: ['256GB', '512GB', '1TB'],
        colors: [
          'Meia-noite',
          'Luz das estrelas',
          'Cinza espacial',
          'Prata',
          'Azul',
          'Verde',
          'Rosa',
          'Amarelo'
        ]
      },
      ipad: {
        lines: ['iPad', 'iPad Air', 'iPad Pro', 'iPad mini'],
        models: ['iPad', 'iPad Air', 'iPad Pro', 'iPad mini'],
        storages: ['128GB', '256GB', '512GB'],
        colors: ['Prata', 'Preto espacial', 'Azul', 'Rosa', 'Amarelo', 'Cinza espacial', 'Roxo', 'Estelar']
      },
      'apple-watch': {
        lines: ['Apple Watch SE', 'Apple Watch Series', 'Apple Watch Ultra'],
        models: ['Apple Watch SE', 'Apple Watch Series 10', 'Apple Watch Ultra 2'],
        storages: ['GPS', 'GPS + Cellular'],
        colors: ['Prata', 'Meia-noite', 'Dourado', 'Titânio natural', 'Estelar']
      },
      airpods: {
        lines: ['AirPods', 'AirPods Pro', 'AirPods Max'],
        models: ['AirPods 4', 'AirPods Pro 2', 'AirPods Max'],
        storages: [],
        colors: ['Branco', 'Verde', 'Azul', 'Rosa', 'Cinza espacial', 'Prata']
      }
    };

    function parentPresetKey(handle) {
      if (!handle) return '';
      if (PRESET_FILTERS[handle]) return handle;
      if (handle.indexOf('iphone') === 0) return 'iphone';
      if (
        handle === 'mac' ||
        handle === 'macbook' ||
        handle.indexOf('mac') === 0 ||
        handle === 'imac' ||
        handle.indexOf('macbook') === 0
      ) {
        return 'mac';
      }
      if (handle.indexOf('ipad') === 0) return 'ipad';
      if (handle.indexOf('apple-watch') === 0) return 'apple-watch';
      if (handle.indexOf('airpods') === 0) return 'airpods';
      return '';
    }

    // iPhone: catálogo atual a partir do 16 / 16e / 17
    if (parentPresetKey(collection) === 'iphone') {
      products = products.filter(function (p) {
        var model = p.filter_model || detectProductModel(p.name || p.search || '');
        p.filter_model = model;
        if (!model) return true;
        if (model.indexOf('iPhone 16') === 0 || model.indexOf('iPhone 17') === 0) return true;
        return false;
      });
    }

    function optionsFrom(list) {
      var presetKey = parentPresetKey(collection);
      var preset = PRESET_FILTERS[presetKey];
      var derived = {
        lines: uniq(
          list.map(function (p) {
            return p.filter_line || p.line;
          })
        ),
        models: uniq(
          list.map(function (p) {
            return p.filter_model || detectProductModel(p.name || p.search || '');
          })
        ),
        storages: uniq(
          list.map(function (p) {
            return p.storage;
          })
        ),
        colors: uniq(
          list.reduce(function (acc, p) {
            if (p.colors && p.colors.length) return acc.concat(p.colors);
            if (p.color) acc.push(p.color);
            return acc;
          }, [])
        )
      };
      if (!preset) return derived;
      return {
        lines: preset.lines.length ? preset.lines : derived.lines,
        models: preset.models && preset.models.length ? preset.models : derived.models,
        storages: preset.storages.length ? preset.storages : derived.storages,
        colors: preset.colors.length ? preset.colors : derived.colors
      };
    }

    var maxPrice = Math.max.apply(
      null,
      [1000].concat(
        products.map(function (p) {
          return p.price || 0;
        })
      )
    );
    state.price = maxPrice;
    if (priceInput) {
      priceInput.min = 0;
      priceInput.max = maxPrice;
      priceInput.step = 100;
      priceInput.value = maxPrice;
    }

    function chipHTML(group, value, label, active) {
      return (
        '<button type="button" class="eden-catalog-filters__chip' +
        (active ? ' is-active' : '') +
        '" data-filter-key="' +
        group +
        '" data-filter-value="' +
        value.replace(/"/g, '&quot;') +
        '">' +
        label +
        '</button>'
      );
    }

    function renderChips() {
      var opts = optionsFrom(products);
      var map = {
        line: opts.lines,
        model: opts.models || [],
        storage: opts.storages,
        color: opts.colors
      };
      Object.keys(map).forEach(function (key) {
        var wrap = page.querySelector('[data-filter-options="' + key + '"]');
        var group = page.querySelector('[data-filter-group="' + key + '"]');
        if (!wrap || !group) return;
        if (!map[key].length) {
          group.hidden = true;
          return;
        }
        group.hidden = false;
        wrap.innerHTML =
          chipHTML(key, '', 'Todos', !state[key]) +
          map[key]
            .map(function (o) {
              return chipHTML(key, o, o, state[key] === o);
            })
            .join('');
      });
    }

    function filtered() {
      return products.filter(function (p) {
        var line = p.filter_line || p.line || '';
        var model = p.filter_model || detectProductModel(p.name || p.search || '');
        var colorList = p.colors && p.colors.length ? p.colors : p.color ? [p.color] : [];
        if (state.line && line !== state.line) return false;
        if (state.model && model !== state.model) return false;
        if (state.storage && p.storage !== state.storage) return false;
        if (state.color && colorList.indexOf(state.color) === -1) return false;
        if (state.price && (p.price || 0) > state.price) return false;
        if (state.q) {
          var hay = (
            p.search || [p.name, p.model, p.storage, colorList.join(' '), p.line, line, model].join(' ')
          ).toLowerCase();
          if (hay.indexOf(state.q.toLowerCase()) === -1) return false;
        }
        return true;
      });
    }

    function render() {
      var list = filtered();
      if (priceLabel) priceLabel.textContent = uiLabels.pricePrefix + ' ' + moneyBRL(state.price || maxPrice);
      if (titleEl && state.line) titleEl.textContent = state.line;
      else if (titleEl && !state.line) {
        // keep original server title unless linha filter active
        var original = titleEl.getAttribute('data-original-title');
        if (!original) {
          titleEl.setAttribute('data-original-title', titleEl.textContent);
          original = titleEl.textContent;
        }
        titleEl.textContent = original;
      }

      if (countEl) {
        countEl.textContent = list.length ? list.length + ' produto(s)' : '';
        countEl.hidden = !list.length;
      }
      if (emptyEl) emptyEl.hidden = list.length > 0;

      if (isDemo) {
        grid.innerHTML = list
          .map(function (p) {
            return cardHTML(p, uiLabels);
          })
          .join('');
      } else {
        products.forEach(function (p) {
          if (!p.el) return;
          var show = list.indexOf(p) !== -1;
          p.el.hidden = !show;
        });
      }
      renderChips();
    }

    page.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter-key]');
      if (!chip) return;
      var key = chip.getAttribute('data-filter-key');
      var value = chip.getAttribute('data-filter-value') || '';
      state[key] = value;
      render();
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.q = searchInput.value || '';
        render();
      });
    }
    if (priceInput) {
      priceInput.addEventListener('input', function () {
        state.price = Number(priceInput.value || maxPrice);
        render();
      });
    }

    render();
  }

  function initDemoGrids() {
    var products = getDemoProducts();
    if (!products.length) return;
    document.querySelectorAll('[data-eden-demo-grid]').forEach(function (grid) {
      var limit = parseInt(grid.getAttribute('data-eden-demo-limit') || '4', 10);
      var collection = (grid.getAttribute('data-eden-demo-collection') || '').toLowerCase();
      var host = grid.closest('[data-ui-buy]') || grid.closest('.eden-featured') || document;
      var labels = {
        buy: host.getAttribute('data-ui-buy') || 'Comprar',
        details: host.getAttribute('data-ui-details') || 'Ver detalhes',
        installmentsPrefix: host.getAttribute('data-ui-installments-prefix') || 'ou',
        installments: parseInt(host.getAttribute('data-ui-installments') || '12', 10) || 12
      };
      var list = products;
      if (collection) {
        list = products.filter(function (p) {
          if (!p.collections || !p.collections.length) return true;
          return p.collections.indexOf(collection) !== -1;
        });
      }
      grid.innerHTML = list
        .slice(0, limit)
        .map(function (p) {
          return cardHTML(p, labels);
        })
        .join('');
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eden-add-cart]');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-eden-product-id]');
      var id = card && card.getAttribute('data-eden-product-id');
      var product = products.find(function (p) {
        return p.id === id;
      });
      if (product) addToCart(product, 1);
    });
  }

  function initShopifyAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-eden-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action + (form.action.indexOf('.js') === -1 ? '.js' : ''), {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function () {
          showToast('Adicionado ao carrinho');
          return fetch('/cart.js').then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          var count = (cart && cart.item_count) || 0;
          document.querySelectorAll('[data-eden-cart-link]').forEach(function (link) {
            var badge = link.querySelector('.eden-header__badge');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'eden-header__badge';
                link.appendChild(badge);
              }
              badge.textContent = String(count);
              badge.hidden = false;
            } else if (badge) {
              badge.hidden = true;
            }
          });
        })
        .catch(function () {
          showToast('Não foi possível adicionar');
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  }

  function initDemoProductPage() {
    var path = (window.location.pathname || '').toLowerCase();
    var match = path.match(/\/products\/(demo-[a-z0-9-]+)/i);
    if (!match) return;

    var products = getDemoProducts();
    if (!products.length) return;
    var product = products.find(function (p) {
      return p.id === match[1];
    });
    if (!product) return;

    var root = document.getElementById('eden-route-root');
    var real404 = document.getElementById('eden-real-404');
    if (!root) return;

    var installments = product.installments || 12;
    var parcela = product.price / installments;
    var imageList = product.images && product.images.length ? product.images : [product.image].filter(Boolean);
    var videoList = product.videos && product.videos.length ? product.videos : [];
    var media = imageList
      .map(function (src) {
        return { type: 'image', src: src };
      })
      .concat(
        videoList.map(function (src) {
          return { type: 'video', src: src };
        })
      );
    if (!media.length) media = [{ type: 'image', src: '' }];

    var meta = [product.storage, product.color, product.condition].filter(Boolean).join(' · ');
    var storyCombo = [product.storage, product.color].filter(Boolean).join(' · ');
    var conditionFull = [product.condition, product.condition_grade].filter(Boolean).join(' — ');
    var model = product.model || product.name;
    var warranty = product.warranty_info || 'Garantia Eden informada no atendimento.';
    var isPro = /pro/i.test(product.line || '');
    var lineDown = String(product.line || '').toLowerCase();
    var storyEyebrow = 'Sobre este produto';
    if (lineDown.indexOf('iphone') !== -1) storyEyebrow = 'Sobre este iPhone';
    else if (lineDown.indexOf('macbook') !== -1) storyEyebrow = 'Sobre este MacBook';
    else if (lineDown.indexOf('ipad') !== -1) storyEyebrow = 'Sobre este iPad';
    else if (lineDown.indexOf('watch') !== -1) storyEyebrow = 'Sobre este Apple Watch';
    else if (lineDown.indexOf('airpods') !== -1) storyEyebrow = 'Sobre estes AirPods';

    var playIcon =
      '<span class="eden-pdp__thumb-play" aria-hidden="true"><span><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span></span>';

    var thumbs =
      media.length > 1
        ? '<div class="eden-pdp__thumbs" data-eden-pdp-thumbs aria-label="Fotos do produto">' +
          media
            .map(function (m, i) {
              var label = m.type === 'video' ? 'Vídeo' : 'Imagem';
              var inner =
                m.type === 'video'
                  ? '<video class="eden-pdp__thumb-img" src="' +
                    m.src +
                    '" muted playsinline></video>' +
                    playIcon
                  : '<img class="eden-pdp__thumb-img" src="' +
                    m.src +
                    '" alt="' +
                    product.name +
                    ' imagem ' +
                    (i + 1) +
                    '" width="120" height="120" loading="lazy">';
              return (
                '<button type="button" class="eden-pdp__thumb' +
                (i === 0 ? ' is-active' : '') +
                '" data-eden-pdp-thumb data-index="' +
                i +
                '" aria-label="' +
                label +
                ' ' +
                (i + 1) +
                '" aria-pressed="' +
                (i === 0 ? 'true' : 'false') +
                '">' +
                inner +
                '</button>'
              );
            })
            .join('') +
          '</div>'
        : '';

    var mainItems = media
      .map(function (m, i) {
        var content =
          m.type === 'video'
            ? '<video class="eden-pdp__main-video" src="' +
              m.src +
              '" controls' +
              (i === 0 ? ' autoplay' : '') +
              ' loop playsinline></video>'
            : '<img class="eden-pdp__main-img" src="' +
              m.src +
              '" alt="' +
              product.name +
              '" width="800" height="1000" loading="' +
              (i === 0 ? 'eager' : 'lazy') +
              '">';
        return (
          '<div class="eden-pdp__main-item' +
          (i === 0 ? ' is-active' : '') +
          '" data-eden-pdp-main data-index="' +
          i +
          '"' +
          (i === 0 ? '' : ' hidden') +
          '>' +
          content +
          '</div>'
        );
      })
      .join('');

    var pedigreeRows = [
      ['Modelo', model],
      ['Linha', product.line],
      ['Capacidade', product.storage],
      ['Cor', product.color],
      ['Condição', conditionFull],
      ['Saúde da bateria', product.battery_health ? product.battery_health + '%' : null],
      ['IMEI', product.imei],
      ['Procedência', product.origin_info],
      ['Garantia', warranty],
      ['Nota fiscal', product.invoice_info]
    ]
      .filter(function (row) {
        return row[1];
      })
      .map(function (row) {
        return '<div class="eden-pdp__row"><dt>' + row[0] + '</dt><dd>' + row[1] + '</dd></div>';
      })
      .join('');

    function colorHex(name) {
      var n = String(name || '').toLowerCase();
      if (/preto|black|midnight|meia-noite/.test(n)) return '#1d1d1f';
      if (/branco|white|starlight|estelar/.test(n)) return '#f5f0e8';
      if (/ultramarino|ultramarine/.test(n)) return '#1e3a5f';
      if (/deserto|desert|areia|sand/.test(n)) return '#c8b59a';
      if (/azul|blue/.test(n)) return '#3b4d6b';
      if (/natural|titânio|titanium|titânio/.test(n) || /titani/.test(n)) return '#c4bfb6';
      if (/rosa|pink/.test(n)) return '#e6cdd3';
      if (/verde|green/.test(n)) return '#5a6b55';
      if (/roxo|purple/.test(n)) return '#594f63';
      if (/prata|silver/.test(n)) return '#e3e4e5';
      if (/espacial/.test(n)) return '#2c2c2e';
      return '#cfc8c0';
    }

    var colorSiblings = [];
    var seenColors = {};
    if (product.color) {
      colorSiblings.push(product);
      seenColors[String(product.color).toLowerCase()] = true;
    }
    var productCols = (product.collections || []).slice();
    products.forEach(function (p) {
      if (p.id === product.id || !p.color) return;
      var key = String(p.color).toLowerCase();
      if (seenColors[key]) return;
      var share = (p.collections || []).some(function (c) {
        return productCols.indexOf(c) !== -1 && c !== 'iphone' && c !== 'mac' && c !== 'macbook' && c !== 'ipad' && c !== 'apple-watch' && c !== 'airpods';
      });
      if (!share && product.line && p.line === product.line) {
        share = true;
      }
      if (!share) return;
      seenColors[key] = true;
      colorSiblings.push(p);
    });

    var colorsHtml = '';
    if (colorSiblings.length) {
      colorsHtml =
        '<div class="eden-pdp__colors" data-eden-pdp-colors>' +
        '<p class="eden-pdp__option-label">Cor <span class="eden-pdp__color-current">' +
        (product.color || '') +
        '</span></p>' +
        '<div class="eden-pdp__color-swatches">' +
        colorSiblings
          .map(function (p) {
            var selected = p.id === product.id;
            var inner =
              '<span class="eden-pdp__color-fallback" style="background:' + colorHex(p.color) + '"></span>';
            if (selected) {
              return (
                '<span class="eden-pdp__color-dot is-selected" title="' +
                (p.color || '') +
                '" aria-current="true">' +
                inner +
                '</span>'
              );
            }
            return (
              '<a href="/products/' +
              p.id +
              '" class="eden-pdp__color-dot" title="' +
              (p.color || '') +
              '" aria-label="' +
              (p.color || '') +
              '">' +
              inner +
              '</a>'
            );
          })
          .join('') +
        '</div></div>';
    }

    var storyDesc =
      product.description ||
      'O ' +
        product.name +
        ' é a união entre engenharia de precisão e uma experiência de uso que se sente desde o primeiro toque. Na Eden Mobile, cada unidade é selecionada e conferida para que você receba não apenas um aparelho, mas a tranquilidade de uma compra bem feita.';

    var finishTitle = isPro ? 'Acabamento em titânio' : 'Acabamento premium';
    var finishText = isPro
      ? 'Estrutura leve e resistente em titânio, com toque refinado e durabilidade que se sente na mão.'
      : 'Materiais nobres com vidro e alumínio, com toque refinado e durabilidade que se sente na mão.';

    var showcaseHtml = '';
    if (imageList.length > 0) {
      var showcaseTitle = model || product.name;
      var showcasePitch = 'Selecionado e conferido pela Eden Mobile.';
      if (isPro) showcasePitch = 'Desempenho Pro, com a tranquilidade Eden.';
      else if (lineDown.indexOf('macbook') !== -1) showcasePitch = 'Potência no dia a dia, escolhida com cuidado.';
      else if (lineDown.indexOf('watch') !== -1) showcasePitch = 'No pulso, com a certeza Eden.';
      else if (lineDown.indexOf('airpods') !== -1) showcasePitch = 'Som impecável, conferido pela Eden.';
      else if (lineDown.indexOf('ipad') !== -1) showcasePitch = 'Criatividade e leveza, prontas para você.';

      var sideImg = imageList[1] || imageList[0];
      showcaseHtml =
        '<section class="eden-pdp-showcase">' +
        '<div class="eden-pdp-showcase__wrap">' +
        '<p class="eden-pdp__section-label">Em detalhe</p>' +
        '<h2 class="eden-pdp-showcase__title">Feito para ser visto de perto.</h2>' +
        '<div class="eden-pdp-showcase__grid">' +
        '<div class="eden-pdp-showcase__hero"><img src="' +
        imageList[0] +
        '" alt="' +
        product.name +
        '" loading="lazy"></div>' +
        '<div class="eden-pdp-showcase__side">' +
        '<div class="eden-pdp-showcase__tile"><img src="' +
        sideImg +
        '" alt="' +
        product.name +
        '" loading="lazy"></div>' +
        '<div class="eden-pdp-showcase__card"><p class="eden-pdp-showcase__card-title">' +
        showcaseTitle +
        '</p><p class="eden-pdp-showcase__card-text">' +
        showcasePitch +
        '</p></div>' +
        '</div></div></div></section>';
    }

    root.hidden = false;
    root.innerHTML =
      '<section class="eden-pdp" data-eden-pdp>' +
      '<div class="eden-pdp__top"><div class="eden-pdp__wrap">' +
      '<div class="eden-pdp__gallery">' +
      '<div class="eden-pdp__main">' +
      mainItems +
      '</div>' +
      thumbs +
      '</div>' +
      '<div class="eden-pdp__info">' +
      '<p class="eden-pdp__eyebrow">' +
      (product.line || 'iPhone') +
      '</p>' +
      '<h1 class="eden-pdp__title">' +
      product.name +
      '</h1>' +
      (meta ? '<p class="eden-pdp__meta">' + meta + '</p>' : '') +
      '<div class="eden-pdp__price-block">' +
      '<p class="eden-pdp__price">' +
      moneyBRL(product.price) +
      '</p>' +
      '<p class="eden-pdp__installments">à vista · ou em até ' +
      installments +
      'x de ' +
      moneyBRL(parcela) +
      '</p>' +
      '<p class="eden-pdp__pay-note">Pix, cartão ou boleto — combinados no atendimento.</p>' +
      '</div>' +
      colorsHtml +
      (product.description ? '<div class="eden-pdp__desc"><p>' + product.description + '</p></div>' : '') +
      '<div class="eden-pdp__actions">' +
      '<button type="button" class="eden-pdp__btn eden-pdp__btn--primary" data-eden-pdp-add>Comprar agora</button>' +
      '<button type="button" class="eden-pdp__btn eden-pdp__btn--outline" data-eden-pdp-add-cart>Adicionar ao carrinho</button>' +
      '</div>' +
      '<div class="eden-pdp__pedigree">' +
      '<p class="eden-pdp__section-label">Eden Pedigree</p>' +
      '<dl class="eden-pdp__dl">' +
      pedigreeRows +
      '</dl></div>' +
      '<div class="eden-pdp__info-box">' +
      '<p class="eden-pdp__section-label">Informações importantes</p>' +
      '<ul class="eden-pdp__info-list">' +
      '<li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.1 7.9-7.5 9-4.4-1.1-7.5-4.4-7.5-9V6L12 3z"/><path d="M9.2 12.1l1.9 1.9 3.7-3.8"/></svg>Compra segura</li>' +
      '<li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 15.5 7.2 18.1l.9-5.4L4.2 8.9l5.4-.8L12 3.2z"/></svg>Produto selecionado</li>' +
      '<li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/></svg>Atendimento personalizado</li>' +
      '<li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/></svg>Nota fiscal, quando aplicável</li>' +
      '<li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>Política de garantia e devolução</li>' +
      '</ul>' +
      '<a href="/collections/faq" class="eden-pdp__policies">Ver políticas</a>' +
      '</div></div></div></div>' +
      '<section class="eden-pdp-story"><div class="eden-pdp-story__wrap">' +
      '<div class="eden-pdp-story__intro"><div>' +
      '<p class="eden-pdp__section-label">' +
      storyEyebrow +
      '</p>' +
      '<h2 class="eden-pdp-story__title">Cada detalhe, considerado.</h2></div>' +
      '<div class="eden-pdp-story__copy"><p class="eden-pdp-story__text">' +
      storyDesc +
      '</p>' +
      (storyCombo
        ? '<p class="eden-pdp-story__text">' +
          storyCombo +
          ' — uma combinação pensada para acompanhar sua rotina com elegância e desempenho por muito mais tempo.</p>'
        : '') +
      '</div></div>' +
      '<div class="eden-pdp-story__features">' +
      '<div class="eden-pdp-story__feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M12 18h.01"/></svg><h3>Tela imersiva</h3><p>Display de alto brilho e cores precisas para conteúdo, leitura e navegação com conforto em qualquer luz.</p></div>' +
      '<div class="eden-pdp-story__feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg><h3>Sistema de câmeras</h3><p>Captação de fotos e vídeos com nitidez notável, do dia à noite, com modos retrato e vídeo em alta resolução.</p></div>' +
      '<div class="eden-pdp-story__feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6v6H9z"/></svg><h3>Desempenho</h3><p>Chip potente para abrir apps, jogos e tarefas pesadas sem hesitar — e que se mantém fluido por anos.</p></div>' +
      '<div class="eden-pdp-story__feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><rect x="2" y="7" width="18" height="10" rx="2"/><path d="M22 11v2"/><path d="M6 11h8"/></svg><h3>Autonomia</h3><p>Bateria dimensionada para o dia inteiro de uso e carregamento rápido quando você precisar.</p></div>' +
      '<div class="eden-pdp-story__feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M12 3l1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3z"/></svg><h3>' +
      finishTitle +
      '</h3><p>' +
      finishText +
      '</p></div>' +
      '<div class="eden-pdp-story__feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.1 7.9-7.5 9-4.4-1.1-7.5-4.4-7.5-9V6L12 3z"/><path d="M9.2 12.1l1.9 1.9 3.7-3.8"/></svg><h3>Privacidade</h3><p>Recursos de segurança que protegem seus dados e seu uso no dia a dia.</p></div>' +
      '</div></div></section>' +
      showcaseHtml +
      '<section class="eden-pdp-assurance"><div class="eden-pdp-assurance__wrap">' +
      '<p class="eden-pdp-assurance__eyebrow">Confiança Eden</p>' +
      '<h2 class="eden-pdp-assurance__title">Comprar com a gente é comprar com calma.</h2>' +
      '<div class="eden-pdp-assurance__grid">' +
      '<div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M12 3l1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3z"/></svg><h3>Inspeção rigorosa</h3><p>Cada aparelho passa por conferência de estado, bateria e funcionamento antes de chegar a você.</p></div>' +
      '<div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/></svg><h3>Procedência verificada</h3><p>Origem clara e documentada para que você compre com certeza.</p></div>' +
      '<div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.1 7.9-7.5 9-4.4-1.1-7.5-4.4-7.5-9V6L12 3z"/><path d="M9.2 12.1l1.9 1.9 3.7-3.8"/></svg><h3>Garantia Eden</h3><p>Condições de garantia descritas em cada produto e nas nossas políticas.</p></div>' +
      '<div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg><h3>Troca e devolução</h3><p>Política transparente, sem letras miúdas.</p></div>' +
      '<div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/></svg><h3>Atendimento humano</h3><p>Fale com uma pessoa real antes e depois da compra.</p></div>' +
      '<div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg><h3>Envio seguro</h3><p>Embalagem protegida e acompanhamento do início ao fim.</p></div>' +
      '</div></div></section>' +
      '<section class="eden-pdp-cta"><div class="eden-pdp-cta__wrap">' +
      '<div class="eden-pdp-cta__copy"><p class="eden-pdp__section-label">Pronto?</p>' +
      '<h2 class="eden-pdp-cta__title">Leve para casa o ' +
      product.name +
      '.</h2>' +
      '<p class="eden-pdp-cta__text">Selecionado, conferido e pronto para acompanhar você. Finalize agora ou fale com a gente para tirar qualquer dúvida.</p></div>' +
      '<div class="eden-pdp-cta__box"><p class="eden-pdp-cta__price">' +
      moneyBRL(product.price) +
      '</p><p class="eden-pdp-cta__installments">à vista · ou em até ' +
      installments +
      'x de ' +
      moneyBRL(parcela) +
      '</p>' +
      '<button type="button" class="eden-pdp__btn eden-pdp__btn--primary eden-pdp-cta__btn" data-eden-pdp-add style="margin-top:1.75rem">Comprar agora <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg></button>' +
      '</div></div></section>' +
      '</section>';

    if (real404) real404.hidden = true;
    document.title = product.name + ' — Eden Mobile';

    initPdpGallery(root);

    root.querySelectorAll('[data-eden-pdp-add], [data-eden-pdp-add-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(product, 1);
        if (btn.hasAttribute('data-eden-pdp-add')) {
          window.setTimeout(function () {
            window.location.href = '/checkout';
          }, 400);
        }
      });
    });
  }

  function initPdpGallery(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-eden-pdp]').forEach(function (pdp) {
      if (pdp.getAttribute('data-eden-gallery-ready') === '1') return;
      pdp.setAttribute('data-eden-gallery-ready', '1');
      var mains = Array.prototype.slice.call(pdp.querySelectorAll('[data-eden-pdp-main]'));
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-eden-pdp-thumb]'));
      if (!thumbs.length || mains.length < 2) return;

      function setActive(index) {
        mains.forEach(function (el, i) {
          var active = i === index;
          el.classList.toggle('is-active', active);
          if (active) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
          var video = el.querySelector('video');
          if (video) {
            if (active) {
              try {
                video.play();
              } catch (err) {}
            } else {
              video.pause();
            }
          }
        });
        thumbs.forEach(function (t, i) {
          var on = i === index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(thumb.getAttribute('data-index') || '0', 10);
          setActive(index);
        });
      });
    });
  }

  function initPdpBuyNow() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-eden-pdp-buy-now]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action + (form.action.indexOf('.js') === -1 ? '.js' : ''), {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          window.location.href = '/checkout';
        })
        .catch(function () {
          showToast('Não foi possível iniciar a compra');
          if (btn) btn.disabled = false;
        });
    });
  }

  function initPdpBuyBox() {
    var pdp = document.querySelector('[data-eden-pdp]');
    if (!pdp) return;

    var variantsEl = pdp.querySelector('[data-eden-pdp-variants]');
    var variants = [];
    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
    } catch (err) {
      variants = [];
    }

    var installments = parseInt(pdp.getAttribute('data-eden-installments') || '12', 10) || 12;
    var pixDiscount = parseInt(pdp.getAttribute('data-eden-pix-discount') || '0', 10) || 0;
    var pixLabel = pdp.getAttribute('data-eden-pix-label') || 'no Pix';
    var stockOk = pdp.getAttribute('data-eden-stock-ok') || 'Disponível';
    var stockOut = pdp.getAttribute('data-eden-stock-out') || 'Indisponível';

    function selectedOptions() {
      var opts = [null, null, null];
      pdp.querySelectorAll('[data-eden-option-value]:checked').forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position') || '1', 10) - 1;
        opts[pos] = input.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return (
          (opts[0] == null || v.option1 === opts[0]) &&
          (opts[1] == null || v.option2 === opts[1]) &&
          (opts[2] == null || v.option3 === opts[2])
        );
      });
    }

    function syncQty() {
      var input = pdp.querySelector('[data-eden-pdp-qty-input]');
      var qty = input ? Math.max(1, parseInt(input.value || '1', 10) || 1) : 1;
      if (input) input.value = String(qty);
      pdp.querySelectorAll('[data-eden-pdp-form-qty]').forEach(function (el) {
        el.value = String(qty);
      });
      return qty;
    }

    function updateUI(variant) {
      if (!variant) return;
      var price = variant.price || 0;
      var compare = variant.compare_at_price || 0;
      var pix = price - Math.floor((price * pixDiscount) / 100);
      var parcela = Math.floor(price / installments);

      pdp.querySelectorAll('[data-eden-pdp-variant-id]').forEach(function (el) {
        el.value = String(variant.id);
      });
      pdp.querySelectorAll('[data-eden-pdp-price-main]').forEach(function (el) {
        el.textContent = moneyBRL(price / 100);
      });
      pdp.querySelectorAll('[data-eden-pdp-parcela]').forEach(function (el) {
        el.textContent = moneyBRL(parcela / 100);
      });
      pdp.querySelectorAll('[data-eden-pdp-pix]').forEach(function (el) {
        el.textContent = moneyBRL(pix / 100) + ' ' + pixLabel;
      });

      var compareEl = pdp.querySelector('.eden-pdp__compare');
      if (compareEl) {
        if (compare > price) {
          compareEl.hidden = false;
          compareEl.textContent = moneyBRL(compare / 100);
        } else {
          compareEl.hidden = true;
        }
      }
      var badge = pdp.querySelector('.eden-pdp__save-badge');
      if (badge) {
        if (compare > price) {
          var pct = Math.round(((compare - price) * 100) / compare);
          badge.hidden = false;
          badge.textContent = (pdp.getAttribute('data-eden-save-label') || 'Economize') + ' ' + pct + '%';
        } else {
          badge.hidden = true;
        }
      }

      var stock = pdp.querySelector('[data-eden-pdp-stock]');
      var stockText = pdp.querySelector('[data-eden-pdp-stock-text]');
      if (stock && stockText) {
        stock.classList.toggle('is-out', !variant.available);
        stockText.textContent = variant.available ? stockOk : stockOut;
      }
      pdp.querySelectorAll('[data-eden-pdp-buy-btn], [data-eden-pdp-add-btn]').forEach(function (btn) {
        btn.disabled = !variant.available;
      });

      pdp.querySelectorAll('.eden-pdp__swatch').forEach(function (label) {
        label.classList.toggle('is-selected', !!(label.querySelector('input:checked')));
      });
      syncQty();
    }

    pdp.addEventListener('change', function (e) {
      if (!e.target.closest('[data-eden-option-value]')) return;
      updateUI(findVariant(selectedOptions()) || variants[0]);
      var colorInput = e.target.closest('[data-eden-color-name]');
      if (colorInput) {
        var current = pdp.querySelector('[data-eden-color-current]');
        if (current) current.textContent = colorInput.getAttribute('data-eden-color-name') || colorInput.value;
        pdp.querySelectorAll('.eden-pdp__color-dot--option').forEach(function (dot) {
          dot.classList.toggle('is-selected', !!(dot.querySelector('input:checked')));
        });
      }
    });

    pdp.addEventListener('click', function (e) {
      var deltaBtn = e.target.closest('[data-eden-qty-delta]');
      if (!deltaBtn) return;
      var input = pdp.querySelector('[data-eden-pdp-qty-input]');
      if (!input) return;
      var delta = parseInt(deltaBtn.getAttribute('data-eden-qty-delta') || '0', 10);
      var next = Math.max(1, (parseInt(input.value || '1', 10) || 1) + delta);
      input.value = String(next);
      syncQty();
    });

    var qtyInput = pdp.querySelector('[data-eden-pdp-qty-input]');
    if (qtyInput) {
      qtyInput.addEventListener('change', syncQty);
    }

    if (variants.length) updateUI(findVariant(selectedOptions()) || variants[0]);
  }

  function initPdpSticky() {
    var bar = document.querySelector('[data-eden-pdp-sticky]');
    var actions = document.querySelector('.eden-pdp__actions');
    if (!bar || !actions) return;
    bar.hidden = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(actions);
  }

  function initPdpComplementary() {
    var root = document.querySelector('[data-eden-complementary]');
    if (!root) return;
    var grid = root.querySelector('[data-eden-complementary-grid]');
    if (!grid) return;
    if (grid.children.length > 0) return;

    var productId = root.getAttribute('data-product-id');
    var limit = parseInt(root.getAttribute('data-limit') || '3', 10) || 3;
    var btnLabel = root.getAttribute('data-btn-label') || 'Ver detalhes';
    if (!productId) return;

    var url =
      '/recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      limit +
      '&intent=complementary';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('rec');
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          root.hidden = true;
          return;
        }
        grid.innerHTML = products
          .map(function (p) {
            var img =
              p.featured_image ||
              (p.images && p.images[0]) ||
              '';
            var price = typeof p.price === 'number' ? p.price / 100 : Number(p.price) || 0;
            return (
              '<article class="eden-card">' +
              '<a href="' +
              p.url +
              '" class="eden-card__media">' +
              (img
                ? '<img src="' + img + '" alt="' + (p.title || '') + '" width="600" height="750" loading="lazy">'
                : '') +
              '</a>' +
              '<div class="eden-card__body">' +
              '<a href="' +
              p.url +
              '" class="eden-card__title">' +
              (p.title || '') +
              '</a>' +
              '<div class="eden-card__price">' +
              moneyBRL(price) +
              '</div>' +
              '<a href="' +
              p.url +
              '" class="eden-btn eden-btn--outline">' +
              btnLabel +
              '</a>' +
              '</div></article>'
            );
          })
          .join('');
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  function initPdpCountdown() {
    var el = document.querySelector('[data-eden-countdown]');
    if (!el) return;
    var endRaw = (el.getAttribute('data-end') || '').trim();
    if (!endRaw) return;

    var normalized = endRaw.replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
      normalized += ':00';
    }
    var end = new Date(normalized).getTime();
    if (!end || isNaN(end)) return;

    var dd = el.querySelector('[data-eden-cd-dd]');
    var hh = el.querySelector('[data-eden-cd-hh]');
    var mm = el.querySelector('[data-eden-cd-mm]');
    var ss = el.querySelector('[data-eden-cd-ss]');

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        return false;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (dd) dd.textContent = pad(days);
      if (hh) hh.textContent = pad(hours);
      if (mm) mm.textContent = pad(mins);
      if (ss) ss.textContent = pad(secs);
      return true;
    }

    if (!tick()) return;
    window.setInterval(function () {
      tick();
    }, 1000);
  }

  function initPdpZoom() {
    var btn = document.querySelector('[data-eden-pdp-zoom]');
    var lightbox = document.querySelector('[data-eden-pdp-lightbox]');
    var img = document.querySelector('[data-eden-pdp-lightbox-img]');
    var closeBtn = document.querySelector('[data-eden-pdp-lightbox-close]');
    if (!btn || !lightbox || !img) return;

    function openZoom() {
      var active = document.querySelector('.eden-pdp__main-item.is-active img, .eden-pdp__main-item:not([hidden]) img');
      if (!active) return;
      img.src = active.currentSrc || active.src;
      img.alt = active.alt || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      lightbox.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', openZoom);
    if (closeBtn) closeBtn.addEventListener('click', closeZoom);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeZoom();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeZoom();
    });
  }

  function initDemoCartPage() {
    var mount = document.querySelector('[data-eden-demo-cart-mount]');
    if (!mount) return;
    var page = document.querySelector('[data-eden-cart-page]') || mount;
    var emptyMsg = mount.getAttribute('data-ui-empty') || page.getAttribute('data-ui-empty') || 'Seu carrinho está vazio.';
    var emptyCta = mount.getAttribute('data-ui-empty-cta') || page.getAttribute('data-ui-empty-cta') || 'Ver produtos';
    var emptyHref = mount.getAttribute('data-ui-empty-href') || page.getAttribute('data-ui-empty-href') || '/collections';
    var totalLabel = mount.getAttribute('data-ui-total') || page.getAttribute('data-ui-total') || 'Total';
    var checkoutLabel = mount.getAttribute('data-ui-checkout') || page.getAttribute('data-ui-checkout') || 'Finalizar pedido';
    var continueLabel = mount.getAttribute('data-ui-continue') || page.getAttribute('data-ui-continue') || 'Continuar comprando';
    var continueHref = mount.getAttribute('data-ui-continue-href') || page.getAttribute('data-ui-continue-href') || '/collections/all';
    var removeLabel = mount.getAttribute('data-ui-remove') || page.getAttribute('data-ui-remove') || 'Remover do carrinho';

    function render() {
      var items = readCart();
      if (!items.length) {
        mount.innerHTML =
          '<p class="eden-featured__empty">' +
          emptyMsg +
          '</p>' +
          '<a href="' +
          emptyHref +
          '" class="eden-btn eden-btn--primary" style="margin-top:1.5rem;display:inline-flex">' +
          emptyCta +
          '</a>';
        return;
      }

      var subtotal = items.reduce(function (s, i) {
        return s + i.price * i.quantity;
      }, 0);

      var rows = items
        .map(function (i) {
          return (
            '<div class="eden-cart-row" data-eden-cart-id="' + i.id + '">' +
            '<img class="eden-cart-row__img" src="' + i.image + '" alt="' + i.name + '" width="80" height="96">' +
            '<div class="eden-cart-row__info">' +
            '<a class="eden-card__title" href="/products/' + i.id + '">' + i.name + '</a>' +
            '<p class="eden-card__meta">' + [i.storage, i.color].filter(Boolean).join(' · ') + '</p>' +
            '<div class="eden-cart-row__qty">' +
            '<button type="button" data-eden-qty="-1" aria-label="Diminuir">−</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button type="button" data-eden-qty="1" aria-label="Aumentar">+</button>' +
            '</div></div>' +
            '<div class="eden-cart-row__side">' +
            '<p class="eden-card__price" style="font-size:1.1rem">' + moneyBRL(i.price * i.quantity) + '</p>' +
            '<button type="button" class="eden-cart-remove" data-eden-remove aria-label="' +
            removeLabel +
            '">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>' +
            '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/>' +
            '</svg></button>' +
            '</div></div>'
          );
        })
        .join('');

      mount.innerHTML =
        '<div class="eden-cart-list">' +
        rows +
        '</div>' +
        '<div class="eden-cart-summary">' +
        '<p class="eden-card__price">' +
        totalLabel +
        ' ' +
        moneyBRL(subtotal) +
        '</p>' +
        '<a href="/checkout" class="eden-btn eden-btn--primary" style="width:100%;margin-top:1.25rem">' +
        checkoutLabel +
        '</a>' +
        '<a href="' +
        continueHref +
        '" class="eden-btn eden-btn--outline" style="width:100%;margin-top:0.75rem;text-align:center">' +
        continueLabel +
        '</a>' +
        '</div>';
    }

    mount.addEventListener('click', function (e) {
      var row = e.target.closest('[data-eden-cart-id]');
      var items = readCart();
      if (!row) return;
      var id = row.getAttribute('data-eden-cart-id');
      var item = items.find(function (i) {
        return i.id === id;
      });
      if (!item) return;

      if (e.target.closest('[data-eden-remove]')) {
        writeCart(
          items.filter(function (i) {
            return i.id !== id;
          })
        );
        render();
        return;
      }

      var qtyBtn = e.target.closest('[data-eden-qty]');
      if (qtyBtn) {
        var delta = parseInt(qtyBtn.getAttribute('data-eden-qty'), 10);
        item.quantity += delta;
        if (item.quantity <= 0) {
          items = items.filter(function (i) {
            return i.id !== id;
          });
        }
        writeCart(items);
        render();
      }
    });

    render();
  }

  function initHeader() {
    var header = document.querySelector('[data-eden-header]');
    if (!header) return;

    var cartLink = header.querySelector('.eden-header__cart');
    if (cartLink) cartLink.setAttribute('data-eden-cart-link', '');

    var setHeight = function () {
      document.documentElement.style.setProperty('--eden-header-height', header.offsetHeight + 'px');
    };
    setHeight();
    window.addEventListener('resize', setHeight);

    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var searchToggle = header.querySelector('[data-eden-search-toggle]');
    var searchPanel = header.querySelector('[data-eden-search]');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        searchPanel.classList.toggle('is-open');
        setHeight();
        if (searchPanel.classList.contains('is-open')) {
          var input = searchPanel.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    var openBtn = header.querySelector('[data-eden-menu-open]');
    var closeBtn = header.querySelector('[data-eden-menu-close]');
    var mobileNav = header.querySelector('[data-eden-mobile-nav]');
    if (openBtn && mobileNav) {
      openBtn.addEventListener('click', function () {
        mobileNav.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      });
    }
    if (closeBtn && mobileNav) {
      closeBtn.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      });
    }
    if (mobileNav) {
      mobileNav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileNav.classList.remove('is-open');
          document.documentElement.style.overflow = '';
        });
      });
    }

    updateCartBadge();
  }

  function initNewsletter() {
    document.querySelectorAll('[data-eden-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var success = form.parentElement.querySelector('[data-eden-newsletter-success]');
        if (form.hasAttribute('data-eden-local')) {
          e.preventDefault();
          form.hidden = true;
          if (success) success.hidden = false;
        }
      });
    });
  }

  function initHeroSlider() {
    var hero = document.querySelector('[data-eden-hero]');
    if (!hero) return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-eden-hero-slide]'));
    var copies = Array.prototype.slice.call(hero.querySelectorAll('[data-eden-hero-copy]'));
    var ctas = Array.prototype.slice.call(hero.querySelectorAll('[data-eden-hero-cta]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-eden-hero-dot]'));
    if (slides.length < 2) return;

    var index = 0;
    var interval = parseInt(hero.getAttribute('data-eden-hero-interval') || '5000', 10);
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (el, i) {
        var active = i === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      copies.forEach(function (el, i) {
        var active = i === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      ctas.forEach(function (el, i) {
        var active = i === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (el, i) {
        var active = i === index;
        el.classList.toggle('is-active', active);
        if (active) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
    }

    function start() {
      if (reduced || timer) return;
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index') || '0', 10);
        stop();
        goTo(i);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function boot() {
    initHeader();
    initNewsletter();
    initDemoGrids();
    initCatalogPage();
    initShopifyAjaxCart();
    initDemoProductPage();
    initPdpGallery(document);
    initPdpBuyNow();
    initPdpBuyBox();
    initPdpSticky();
    initPdpZoom();
    initPdpCountdown();
    initPdpComplementary();
    initDemoCartPage();
    initHeroSlider();
    updateCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
